export default ":host{display:block}";